"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICON_NAMES = exports.iconSet = void 0;
const config_json_1 = __importDefault(require("./config.json"));
exports.iconSet = config_json_1.default;
// Exporting the full list of icon names makes it easier to list all available
// icons in StoryBook.
exports.ICON_NAMES = config_json_1.default.icons.map((icon) => icon.properties.name);
